import { Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import AIButton from "@/components/AIComponents/AiButton";
import AISpark from "@/components/AIComponents/ExportablesModal/AISpark.svg";
import ExportablesBaseModal from "@/components/AIComponents/ExportablesModal/ExportablesBaseModal";
import { sectionCss } from "@/view/TeacherActivityContainer/TeacherActivityContainer.style";
import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";

const AIButtonWithTrackEvent = withTrackEvent(AIButton);

/**
 * TODO:
 * This component must be deleted once the Assignable Graphic Organizers
 * experiment rolls out to 100%
 */
const TeacherComponentLegacy = () => {
  const {
    content,
    isContentSupported,
    handleTemplateSelection,
    isInAssignGraphicOrganizersExperiment,
    modalTriggerRef,
  } = useExportablesContext();

  const handleOpenModal = () => {
    handleTemplateSelection();
  };

  if (!isContentSupported || isInAssignGraphicOrganizersExperiment) return null;

  return (
    <div css={sectionCss}>
      <AIButtonWithTrackEvent
        icon={{
          SvgComponent: AISpark,
          alignment: Button.iconAlignments.right,
        }}
        isFullWidth
        onClick={handleOpenModal}
        ref={modalTriggerRef}
        dataProps={{
          "data-qa-selector": "open-exportables-modal-button",
        }}
        // Event tracking props
        actionPrefix={actionPrefixes.initiate}
        actionName={actionNames.interact}
        objectType={objectTypes.content}
        streamProperties={{
          description: `Open modal for exportable resources`,
          content_id: content.id,
        }}
      >
        Generate graphic organizers
      </AIButtonWithTrackEvent>

      <ExportablesBaseModal isStudent={false} />
    </div>
  );
};

export default TeacherComponentLegacy;
